import ActionTypes from 'redux/ActionTypes';

export const toggleModal = (modalName, modalState = false) => ({
	type: ActionTypes.TOGGLE_MODAL,
	payload: {
		modalName,
		modalState,
	},
});

export const setMsg = (modalMsg) => ({
	type: ActionTypes.SET_MSG,
	payload: modalMsg,
});

export const showCloseIcon = (modalClose = true) => ({
	type: ActionTypes.SHOW_CLOSE,
	payload: modalClose,
});

export const toggleError = (modalError = true) => ({
	type: ActionTypes.TOGGLE_ERROR,
	payload: modalError,
});
